/**
 * Shows how many cards of the collection are on screen.
 *
 * The grid renders one card per color, so a page holds a variable number of
 * cards and the server cannot know how many are visible once "load more" has
 * appended a few pages. Counting the rendered cards keeps the figure right for
 * any combination of pages, including a direct hit on ?page=N.
 *
 * Markup contract:
 *   data-grid     CSS selector for the grid container (defaults to the theme's)
 *   data-template copy with a __SEEN__ placeholder, already translated
 */
class EyelitLoadProgress extends HTMLElement {
  connectedCallback() {
    this.output = this.querySelector('[data-progress-text]');
    this.grid = document.querySelector(this.dataset.grid || '[data-products-grid]');

    if (!this.output || !this.grid) return;

    this.template = this.dataset.template || '';
    this.update();

    this.observer = new MutationObserver(() => this.update());
    this.observer.observe(this.grid, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  update() {
    const seen = this.grid.querySelectorAll('.product-card').length;
    this.output.textContent = this.template.replace('__SEEN__', seen);
  }
}

if (!customElements.get('eyelit-load-progress')) {
  customElements.define('eyelit-load-progress', EyelitLoadProgress);
}
